import { Outlet } from "react-router-dom";
import PageHeader from "../Guest/sections/PageHeader";
import Footer from "../Guest/sections/PageFooter";
import Banner from "../Guest/sections/PageBanner";

export default function GuestLayout() {
  return (
    <>
    <Banner />
    <PageHeader />
      <Outlet />
    <Footer />
    </>
  );
}
